import { FC, useEffect, useMemo, useState } from 'react'
import ContactPush, { ContactPushProps } from 'src/components/ContactPush'
import { useTranslation } from 'react-i18next'
import { useServiceRequest } from 'src/hooks/useServiceRequest'
import { actions, selectors } from 'src/redux'
import { useSelector } from 'react-redux'

import { BlockProps } from '../props'

import { BlocContactProps } from './props'

const BlocContact: FC<BlockProps<BlocContactProps>> = ({ data }) => {
  const { t } = useTranslation()
  const isInit = useSelector(selectors.app.isInit)

  const { request, response } = useServiceRequest(
    selectors.mail.sendMessage,
    actions.mail.sendMessageRequest,
    actions.mail.sendMessageReset
  )

  const [stateSuccess, setStateSuccess] = useState(false)

  useEffect(() => {
    setStateSuccess(response.success ? true : false)
  }, [response.success])

  const props: ContactPushProps = useMemo(
    () => ({
      blockTitle: {
        title: stateSuccess && isInit ? t('contact.success') : data.title || '',
        tag: data.sectionTitle || '',
      },
      resetHandler: () => {
        setStateSuccess(false)
      },
      form: {
        onSubmit: (values) => {
          request({
            data: {
              firstName: values.lastname,
              lastName: values.name,
              message: values.message,
              email: values.email,
              recipient: data.recipient ?? '',
            },
          })
        },
        initialValues: {
          email: '',
          lastname: '',
          name: '',
          message: '',
          optin: false,
        },
        fields: {
          name: {
            required: true,
            label: t('contact.fields.name'),
            placeholder: t('contact.fields.name.placeholder'),
          },
          lastname: {
            required: true,
            label: t('contact.fields.lastname'),
            placeholder: t('contact.fields.lastname.placeholder'),
          },
          email: {
            required: true,
            label: t('contact.fields.email'),
            placeholder: t('contact.fields.email.placeholder'),
          },
          message: {
            required: true,
            label: t('contact.fields.message'),
            placeholder: t('contact.fields.message.placeholder'),
          },
          optin: {
            required: true,
            label: t('contact.fields.optin'),
          },
        },
        texts: {
          errorSent: response.errors ? t('contact.error') : undefined,
          submitLabel: t('contact.actions.submit'),
          validationEmail: t('yup.email'),
          validationOptin: t('yup.opt'),
          validationRequired: t('yup.required'),
        },
      },
      texts: {
        reset: t('contact.actions.reset'),
      },
    }),
    [
      data.recipient,
      data.sectionTitle,
      data.title,
      isInit,
      request,
      response.errors,
      stateSuccess,
      t,
    ]
  )

  return <ContactPush {...props} success={isInit && stateSuccess} />
}

export default BlocContact
